import * as Yup from 'yup'

export const validationSchema = Yup.object({
  ClosesOn: Yup.date()
    .min(new Date(), 'Closing date must be in the future')
    .nullable(),
  Description: Yup.string().required('Description is required'),
  Hero: Yup.string().required(),
  HeroFile: Yup.array(),
  IsHidden: Yup.boolean(),
  Name: Yup.string().required('Registry name is required'),
  RegionId: Yup.string().optional(),
  IsClosed: Yup.boolean().optional().nullable(),
  IsCampaign: Yup.boolean().optional().nullable(),
  AccountId: Yup.string().optional().nullable(),
  Summary: Yup.string().optional().nullable(),
  Uri: Yup.string()
    .optional()
    .nullable()
    .test(
      'uri_validation',
      'Uri should only contain text, numbers and dashes (e.g. my-tree-registry or mytreeregistry)',
      v => {
        return !v || /^[a-z0-9-]*$/gi.test(v)
      }
    )
})
